import { Component, EventEmitter, Input, Output } from '@angular/core';
import { EcondosFilter } from '@api/util/filter';

@Component({
  selector: 'app-active-filters',
  template: `
    <ng-container *ngFor="let filter of filters; let i = index">
      <nz-tag *ngIf="filter.value" class="flex items-center space-x-1" [attr.data-testid]="'active-filters-' + (i + 1) + '-close-button'">
        <span>{{ filter.label }}: {{ filter.value === 'true' ? 'Sim' : filter.value === 'false' ? 'Não' : filter.value }}</span>

        <i nz-icon nzType="close" class="cursor-pointer ml-1" (click)="onCloseClick(filter.value, i)"></i>
      </nz-tag>
    </ng-container>
  `
})
export class ActiveFiltersComponent {
  @Input() filters: EcondosFilter[] = [];

  @Output() removeClick = new EventEmitter<{ value: any; index: number }>();

  onCloseClick(value: any, index: number): void {
    this.removeClick.emit({ value, index });
  }
}
